import { Suspense } from "react";
import { Route, Routes } from "react-router";
import { protectedRoute, Route as RouteProp } from "./protected";
// import Login from "../pages/Auth/Login";
import NotFound from "../components/UI/NotFound";
import { Layout } from "../components/Layout";
import { publicRoute } from "./public";
import { PublicLayout } from "../components/Layout/publicLayout";

export const AppRouter = () => {
  return (
    <Suspense>
      <Routes>
        <Route element={<Layout />}>
          {protectedRoute
            .filter((route: RouteProp) => route.protected)
            .map((route: RouteProp) => {
              const Comp = route.component;

              return (
                <Route key={route.name} path={route.path} element={<Comp />} />
              );
            })}

          <Route path="*" element={<NotFound />} />
        </Route>
        <Route element={<PublicLayout />}>
          {publicRoute
            .filter((route: RouteProp) => !route.protected)
            .map((route: RouteProp) => {
              const Comp = route.component;

              return (
                <Route key={route.name} path={route.path} element={<Comp />} />
              );
            })}
        </Route>
      </Routes>
    </Suspense>
  );
};
